import { render, staticRenderFns } from "./namelist.vue?vue&type=template&id=42616b95"
import script from "./namelist.vue?vue&type=script&lang=js"
export * from "./namelist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports